// extracted by mini-css-extract-plugin
module.exports = {"title":"appointments__AppointmentTypeSelect__title"};